import { render } from "./UsidxTrend.vue?vue&type=template&id=3b8fd480&scoped=true"
import script from "./UsidxTrend.vue?vue&type=script&lang=js"
export * from "./UsidxTrend.vue?vue&type=script&lang=js"

import "./UsidxTrend.vue?vue&type=style&index=0&id=3b8fd480&scoped=true&lang=css"

import exportComponent from "/Users/dongjoosong/Code/dp7stage/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3b8fd480"]])

export default __exports__